import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../slices/types';
import SendNotification from './SendNotification';

const SendNotificationPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation() as any;
  const defaultUser = location?.state?.defaultUser ?? null;
  const { users: adminUsers } = useAppSelector((s) => s.AdminUsers);

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Send Notification</h1>
        <p className="text-gray-600">Choose scope and compose your message</p>
      </div>
      <SendNotification users={adminUsers} defaultUser={defaultUser} onClose={() => navigate(-1)} />
    </div>
  );
};

export default SendNotificationPage;


